import cat from "../assets/cat.png";

export default function NotFound404() {
  return (
    <div className="min-h-[100vh] min-h-dvh flex flex-col items-center justify-center bg-background text-foreground p-lg text-center gap-lg overflow-hidden">
      <img
        src={cat}
        alt="picture of cat"
        className="w-[220px] max-[375px]:w-[180px] opacity-90"
      />
      <div className="flex flex-col items-center gap-sm">
        <h1 className="text-[48px] max-[375px]:text-[40px] font-bold tracking-tight leading-none">
          404
        </h1>
        <p className="text-md text-muted-fg leading-relaxed max-w-[280px]">
          Nothing here but sand and silence.
        </p>
      </div>
      <a
        href="/app/"
        className="btn-primary h-[52px] px-xl rounded-full bg-foreground text-primary-fg text-base font-semibold inline-flex items-center justify-center cursor-pointer shadow-[0_2px_8px_rgba(0,0,0,0.12)]"
      >
        Take me home
      </a>
    </div>
  );
}
